import { formatDate } from '@/components/live';

export type ValidityState = 'valid' | 'expiring' | 'expired' | 'none';

/** The same rule as platform.fn_validity_state (migration 0075): expiring = within 30 days. */
export function validityState(validTo?: string | null): ValidityState {
  if (!validTo) return 'none';
  const today = new Date();
  const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  if (validTo < todayIso) return 'expired';
  const soon = new Date(today.getTime() + 30 * 86400000);
  const soonIso = `${soon.getFullYear()}-${String(soon.getMonth() + 1).padStart(2, '0')}-${String(soon.getDate()).padStart(2, '0')}`;
  return validTo <= soonIso ? 'expiring' : 'valid';
}

const LABEL: Record<ValidityState, string> = { valid: 'Valid', expiring: 'Expiring', expired: 'Expired', none: 'No validity' };

/**
 * Every consent and digital record carries a validity (owner, 2026-09-21). One badge everywhere:
 * the end date, and whether it is still valid, expiring within 30 days, or expired.
 */
export function ValidityBadge({ from, to, compact }: { from?: string | null; to?: string | null; compact?: boolean }) {
  const state = validityState(to);
  return (
    <span className={`validity validity-${state}`} title={from ? `${formatDate(from)} to ${formatDate(to)}` : undefined}>
      <span className="validity-dot" />{LABEL[state]}{to && !compact ? ` · to ${formatDate(to)}` : ''}
    </span>
  );
}

/** A date `months` after `from` (yyyy-mm-dd), for a default end date. */
export function addMonths(from: string, months: number): string {
  const [y, m, d] = from.split('-').map(Number);
  const date = new Date(y!, (m! - 1) + months, d!);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
